<template>
    <div class="article">
        <NavComponent></NavComponent>
        <SideBarComponent></SideBarComponent>
        <div class="main">
            <h3>{{activeList.title}}</h3>
            <div></div>
            <div class="article-content" v-html="activeList.content"></div>
        </div>
        <FooterComponent></FooterComponent>
    </div>
</template>
<script>
import FooterComponent  from '@components/FooterComponent'
import NavComponent  from '@components/NavComponent'
import SideBarComponent from '@components/SideBarComponent'

export default {
    name: 'MoveHousePage',
    computed:{

    },
    components: {
        FooterComponent,
        NavComponent,
        SideBarComponent,
    },
    data(){
        return {
            activeList:{}
        }
    },
    mounted(){
        this.articleId = this.$route.query.id
        this.getDetail(this.$route.query.id)
    },
    methods:{
        getDetail(id){
            var that = this
            this.axios.get(this.url+'/api/web/cms/detail',{params:{'id':id}}).then(function(response){
                that.activeList = response.data.data
            }).catch(function() {
            });
            },
        }

}
</script>
<style lang="scss" scoped>
.main{
    min-height: 45vh;
    padding: 2rem 0;
    text-align: center;
    h3{
        line-height: 3rem;
        margin-bottom: 2rem;
    }
}
</style>
<style lang="scss">
.article .article-content{
    img{
        width: 750px !important;
        height: auto !important;
    }
}
</style>